"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PopupPanel = (0, vue_1.resolveComponent)("PopupPanel");
    return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_PopupPanel, {
        onClose: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
    }, {
        header: (0, vue_1.withCtx)(() => [...(_cache[1] || (_cache[1] = [
                (0, vue_1.createElementVNode)("h2", null, "Keyboard Shortcuts", -1)
            ]))]),
        default: (0, vue_1.withCtx)(() => [
            _cache[4] || (_cache[4] = (0, vue_1.createTextVNode)(" A - Main Board", -1)),
            _cache[5] || (_cache[5] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            _cache[6] || (_cache[6] = (0, vue_1.createTextVNode)(" S - Players Overview Table", -1)),
            _cache[7] || (_cache[7] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            _cache[8] || (_cache[8] = (0, vue_1.createTextVNode)(" D - Cards in Hand", -1)),
            _cache[9] || (_cache[9] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            _cache[10] || (_cache[10] = (0, vue_1.createTextVNode)(" F - Colonies", -1)),
            _cache[11] || (_cache[11] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            (_ctx.preferences().experimental_ui)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                    _cache[2] || (_cache[2] = (0, vue_1.createElementVNode)("br", null, null, -1)),
                    _cache[3] || (_cache[3] = (0, vue_1.createTextVNode)(" 1-9 - Scroll through the player board. ", -1))
                ], 64))
                : (0, vue_1.createCommentVNode)("", true),
            _cache[12] || (_cache[12] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            _cache[13] || (_cache[13] = (0, vue_1.createTextVNode)(" ? - Show this help", -1)),
            _cache[14] || (_cache[14] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            _cache[15] || (_cache[15] = (0, vue_1.createTextVNode)(" ESC - close this help", -1)),
            _cache[16] || (_cache[16] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            _cache[17] || (_cache[17] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            _cache[18] || (_cache[18] = (0, vue_1.createTextVNode)("More coming. ", -1))
        ]),
        _: 1
    }));
}
